import { useEffect, useRef, useState } from "react";

interface AccountMenuProps {
  onOpenSessions: () => void;
  onLogOut: () => void;
}

/**
 * Top-bar account dropdown -- same trigger/dropdown shape as kwms-web's own
 * TopBar account menu, trimmed to what this app actually has to offer right
 * now ("Активные сессии" + "Выйти"; no editable profile fields exist here,
 * see SessionsView.tsx's own doc comment on why -- add entries as those get
 * built, don't pre-add dead links).
 */
export function AccountMenu({ onOpenSessions, onLogOut }: AccountMenuProps) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="account-menu" ref={menuRef}>
      <button
        className="account-menu-trigger"
        aria-label="Аккаунт"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.6" />
          <path d="M5 19c1-3.5 4-5 7-5s6 1.5 7 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </button>
      {open && (
        <div className="account-menu-dropdown" role="menu">
          <button
            className="account-menu-item"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              onOpenSessions();
            }}
          >
            Активные сессии
          </button>
          <button
            className="account-menu-item account-menu-item-danger"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              onLogOut();
            }}
          >
            Выйти
          </button>
        </div>
      )}
    </div>
  );
}
